/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PartnerType {
    BrandWorkshop = 0,
    ChainWorkshop = 1,
    IndependentWorkshop = 2,
}